module.exports = __webpack_public_path__ + "static/media/fitnessWhite.bbcc535b.svg";